export const linkUsersToLocationStyles = {
  autocomplete: {
    height: "57px",
  },
  textField: {
    width: "40vw",
    maxWidth: "calc(100% - 20px)",
    marginBottom: "24px",
    marginLeft: "24px",
    marginTop: "24px",
  },
  tagsBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  stickyOptionBox: {
    position: "sticky",
    top: "-1rem",
    background: "#fff",
    height: "60px",
    zIndex: "2",
    borderBottom: "1px solid",
  },
  checkboxOption: {
    marginRight: 8,
  },
  button: {
    textTransform: "none",
  },
};
